import Vue from 'vue'
import VueI18n from 'vue-i18n'

import config from '../package.json'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import {
  Alert,
  Affix,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Carousel,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  Form,
  FormModel,
  Icon,
  Input,
  Layout,
  List,
  Menu,
  message,
  Modal,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Result,
  Row,
  Select,
  Spin,
  Switch,
  Steps,
  Tabs,
  Tag,
  Table,
  TimePicker,
  Tooltip,
  Tree,
  Upload,
} from 'ant-design-vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'

import { messages, dateTimeFormats } from '@/i18n/i18n'
import { getLocale, setLocale } from '@/utils/utils'

Vue.use(VueI18n)

Vue.use(Alert)
Vue.use(Affix)
Vue.use(Avatar)
Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(Button)
Vue.use(Calendar)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(ConfigProvider)
Vue.use(Carousel)
Vue.use(DatePicker)
Vue.use(Descriptions)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Layout)
Vue.use(List)
Vue.use(Menu)
Vue.use(Modal)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Result)
Vue.use(Row)
Vue.use(Select)
Vue.use(Spin)
Vue.use(Switch)
Vue.use(Steps)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Table)
Vue.use(TimePicker)
Vue.use(Tooltip)
Vue.use(Tree)
Vue.use(Upload)

Vue.prototype.$info = Modal.info
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message

Vue.config.productionTip = false

let locale = getLocale()
if (!locale) {
  const systemLanguage = navigator.language
  if (systemLanguage === 'en') {
    locale = 'en'
    setLocale('en')
    store.commit('setLocale', 'en')
  } else {
    locale = 'zh'
    setLocale('zh')
    store.commit('setLocale', 'zh')
  }
}
const i18n = new VueI18n({
  locale,
  dateTimeFormats,
  fallbackLocale: 'zh',
  messages,
})

if (process.env.VUE_APP_ENV === 'PRODUCTION') {
  Sentry.init({
    Vue,
    release: 'enseed-admin@' + config.version,
    environment: process.env.VUE_APP_ENV,
    dsn: 'https://220178ba2f284da68ddb211efe2a9df9@sentry.dipont.com:9000/2',
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
